import type { EmbedDefinition } from './types';

class EmbedRegistry {
  private providers = new Map<string, EmbedDefinition>();

  register(definition: EmbedDefinition): void {
    this.providers.set(definition.id, definition);
  }

  get(id: string): EmbedDefinition | undefined {
    return this.providers.get(id);
  }

  getAll(): EmbedDefinition[] {
    return Array.from(this.providers.values());
  }

  detectType(url: string): string | null {
    for (const provider of this.providers.values()) {
      if (provider.matcher(url)) {
        return provider.id;
      }
    }

    return null;
  }

  convertUrl(url: string, type?: string): string {
    const embedType = type || this.detectType(url);
    if (!embedType) return url;

    const provider = this.providers.get(embedType);

    return provider ? provider.convertUrl(url) : url;
  }
}

export const embedRegistry = new EmbedRegistry();

/**
 * Detects embed type from URL using the registry
 * Returns null if URL doesn't match any embed pattern
 */
export const detectEmbedType = (url: string) => embedRegistry.detectType(url);
